import type { pisti } from "@app/rules";
import type { T } from "./tableText";

/**
 * Pişti in words. Only the seat line: the toast band lies over the middle of the table, where the
 * pile is, so a capture and a pişti are shown there (`PistiPile`) and the deck's count is a table
 * of its own (`PistiCount`) instead of a toast.
 */

const teamOf = (seat: number) => (seat % 2 === 0 ? 0 : 1);

/** Under every name: what that seat's team has taken so far this deck. */
export function pistiSeatSub(view: pisti.PistiView, seat: number, _you: number | null, t: T) {
  const team = teamOf(seat);
  // While a capture rests, the seat that made it says so: the eye goes to who took the pile.
  if (view.sweep?.seat === seat) return t("pisti.seat.took", { cards: view.sweep.taken });
  return t("pisti.seat", {
    cards: view.captured[team] ?? 0,
    pistis: view.pistiCards[team]?.length ?? 0,
  });
}
